module.exports = __webpack_public_path__ + "img/dinner.b336c104.svg";